import React from 'react'
import "./page.css"
import RewardsIcon from "../assets/rewards-icon.png"
import ArrowLeft from "../assets/left-icon.png"
import { Link } from 'react-router-dom'
export default function EventOffer() {
  return (
    <div>
      <div className='rewards_section'>
        <div className='container'>
          <div className='rewards_heading'>
            <img src={RewardsIcon} />
            <p>Book Now & Earn Rewards</p>
          </div>
        </div>
      </div>

      <div className='inner_title_section'>
        <div className='container'>
          <div className='inner_title_flex'>
            <Link to='/booking'> <img src={ArrowLeft} /></Link>
            <h3>Event</h3>
          </div>
        </div>
      </div>
    </div>

  )
}
